import IWebPhoneService from '../IWebPhoneService';
import { phoneState } from '../state';
import { WebphoneCallState } from '../types';
import handleCallEnded from './handleCallEnded';
import handleCallAnswered from './handleCallAnswered';
import handleCallMissed from './handleCallMissed';
import IAppLogger from '@app/lib/IAppLogger';

const handleCallStateUpdate = async (
  webPhoneService: IWebPhoneService,
  updatedCallState: WebphoneCallState,
  currentCallState: WebphoneCallState,
  logger: IAppLogger,
) => {
  const { callId } = updatedCallState;

  const callAttributes = phoneState.callAttributes[callId];

  // create the call event from the state and call attributes
  const newCallEvent = { ...currentCallState, ...callAttributes };
  // check for state changes
  const established = updatedCallState.established;

  if (!established && currentCallState.progress && !updatedCallState.progress) {
    // by the time we get here, the call has already ended
    // and the callState has been reset. send the previous call state
    handleCallMissed(webPhoneService, newCallEvent, logger);
  } else if (currentCallState.established && !updatedCallState.established) {
    // by the time we get here, the call has already ended
    // and the callState has been reset. send the previous call state
    handleCallEnded(webPhoneService, newCallEvent, logger);
  } else if (!currentCallState.established && updatedCallState.established) {
    handleCallAnswered(webPhoneService, newCallEvent, logger);
  }
};

export default handleCallStateUpdate;
